// extracted by mini-css-extract-plugin
export default {"myHeader":"sdtoFkl4E4XXUjFjqdnu","title":"hxYpeBntGAer28ecC8GR","link":"uSTNQOxaicywFH4q7hd6","poem":"aEq7gA7O8sW29uFPeipr","webSlogan":"mScBUuu8NubGQNwMqAVa"};